export default {
      id: "heart.sprite-usage",
      viewBox: "0 0 22 18",
      url: __webpack_public_path__ + "sprite.svg#heart.sprite-usage",
      toString: function () {
        return this.url;
      }
    }